import { RootState } from '..';

export const getDefaultTracksSource = (state: RootState) => state.tracks.source || 'unknown';
